import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { handleErrorResponse } from "../../apis";

export const receiveOrder = createAsyncThunk('receiveOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/receive-order`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});